import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Amplify } from 'aws-amplify';

import "./utility/i18n";


Amplify.configure({
    Auth:{
        Cognito: {
            userPoolClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID as string,
            userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID as string
        }
    }
});

const root = createRoot(document.getElementById('root')!) // createRoot(container!) if you use TypeScript
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
